@mixin copy_margin {
  margin-top: $sd-spacing-5;
  margin-bottom: 0;

  @include breakpoint($medium) {
    margin-top: $sd-spacing-6;
  }
}

@mixin channel_contactbox {
  .copy {
    @include copy_margin();
  }

  .button {
    margin-top: $sd-spacing-6;
  }

  address {
    font-style: normal;
  }
}

ui-cms-contact-channels {
  display: block;

  .wrapper {
    display: flex;
    flex-wrap: wrap;

    .channel {
      display: flex;
      vertical-align: top;
    }
  }

  .column-count {
    &--1 .channel {
      width: 100%;

      .button {
        width: 100%;
      }

      .channel-contactbox {
        padding-right: 0;
      }
    }

    &--2 .channel {
      width: 50%;
    }

    &--3 .channel {
      width: 33.3333%;
    }
  }

  .buttons-aligned .channel-contactbox {
    display: flex;
    justify-content: space-between;
    flex-direction: column;

    .up {
      justify-content: normal;
    }
  }

  .channel-contactbox {
    margin-top: $sd-spacing-10;
    padding-left: 0;
    padding-right: $sd-spacing-10;
    width: 100%;

    h4 {
      margin: 0;
    }

    sd-icon {
      width: 3rem;
      height: 3rem;
      min-width: 3rem;
    }
  }
}
